/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateFaqMutationRequest,
  UpdateFaqMutationResponse,
  UpdateFaqPathParams,
} from "../types/UpdateFaq.ts"

export const updateFaqMutationKey = () =>
  [{ url: "/v1/faq/update-faq/:id" }] as const

export type UpdateFaqMutationKey = ReturnType<typeof updateFaqMutationKey>

/**
 * @summary Update a FAQ entry
 * {@link /v1/faq/update-faq/:id}
 */
export async function updateFaq(
  id: UpdateFaqPathParams["id"],
  data: UpdateFaqMutationRequest,
  config: Partial<RequestConfig<UpdateFaqMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateFaqMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateFaqMutationRequest
  >({
    method: "PUT",
    url: `/v1/faq/update-faq/${id}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateFaqMutationOptions(
  config: Partial<RequestConfig<UpdateFaqMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = updateFaqMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateFaqPathParams["id"]; data: UpdateFaqMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return updateFaq(id, data, config)
    },
  })
}

/**
 * @summary Update a FAQ entry
 * {@link /v1/faq/update-faq/:id}
 */
export function useUpdateFaq<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateFaqMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: UpdateFaqPathParams["id"]; data: UpdateFaqMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateFaqMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateFaqMutationKey()

  const baseOptions = updateFaqMutationOptions(config) as UseMutationOptions<
    ResponseConfig<UpdateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateFaqPathParams["id"]; data: UpdateFaqMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateFaqPathParams["id"]; data: UpdateFaqMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateFaqPathParams["id"]; data: UpdateFaqMutationRequest },
    TContext
  >
}
